// NPM Imports
import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";

// Components Imports
import AttachWorkflowBtn from "../AttachWorkflowBtn";

// Action Imports
import { DocumentTemplateActions } from "../../../../actions";
import {
  updateDocumentComponentAction,
  forceUpdateEditorSectionIdAction,
} from "../../../../actions/DocumentActions";

// Method Imports
import { getDynamicFieldIDs } from "../../../../actions/DocumentTemplateActions/templateMethod";

// Service Imports
import { updateTemplateComponentService } from "../../../../actions/DocumentTemplateActions/templateService";

// import utils
import { removeEntityAndReplaceText } from "../../../../utils/draftUtils";
import { getFormFields } from "../../../../utils/editorUtils";
import {
  getComponentMetaFromEntity,
  getComponentEditorData,
} from "../../../../utils/components";
import { getUpdatedParentComponent } from "../../../../utils/documentUtils";

// Internal Imports
import { COMMON } from "../../../../constants";
import { DOCUMENT_COMPONENT_TYPES } from "../../../../constants/document";

// Destructuring
const {
  toggleDynamicFieldView,
  toggleWorkFlowScreen,
  getCustomFieldType,
  selectedDynamicFieldDataForUpdate,
} = DocumentTemplateActions;
const { DOCUMENT_LABELS } = COMMON;

// Declaration
const INFO = "INFO";

function DynamicFieldList(props) {
  /**
   * This func allows to create a list the dynamic fields with top to bottom order in which the
   * document is displayed in UI.
   */
  function _getDynamicFieldList() {
    const fieldCount = {};
    Object.keys(props.dynamicField).forEach(field => {
      fieldCount[field] = 0;
    });
    let fieldList = getFormFields(props.components);
    if (props.coverpageFormFields) {
      const cpFieldIds = [];
      props.coverpageFormFields.forEach(item => cpFieldIds.push(item.id[0]));
      fieldList = fieldList.filter(item => !cpFieldIds.includes(item.id));
    }
    const formFields = [];
    fieldList.forEach(field => {
      const { dynamicFieldId } = field;
      // get the selected dynamic field
      if (dynamicFieldId in props.dynamicField) {
        const selectedDynamicField = props.dynamicField[dynamicFieldId];
        fieldCount[dynamicFieldId] += 1;
        const {
          type,
          label,
          description,
          selectedText,
          wf_id: wfId,
          workflow_enabled: workflowEnabled,
        } = selectedDynamicField;
        formFields.push({
          ...field,
          wfId,
          label: `${label} (${fieldCount[dynamicFieldId]})`,
          df_type: type,
          description,
          selectedText,
          workflowEnabled,
        });
      }
    });
    // When all the dynamic fileds have been deleted show the INFO View in the rightside pane
    if (formFields.length === 0 && props.view === "LIST")
      props.toggleDynamicFieldView(INFO);
    return formFields;
  }

  function _scrollToView(fieldID) {
    const component = document.getElementById(fieldID);
    if (component !== null) {
      component.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.error("component not found");
    }
  }

  function _goForUpdateFormField(data) {
    console.debug("_goForUpdateFormField", data);
    props.getCustomFieldType();
    props.selectedDynamicFieldDataForUpdate(
      data.dynamicField[data.entity.dynamicFieldId],
    );
  }

  function _removeDynamicFiled(event, entity) {
    event.preventDefault();
    const oldFormFields = getDynamicFieldIDs(props.components);

    // remove entity from section editor data
    const componentMeta = getComponentMetaFromEntity(props.components, entity);
    const editorData = getComponentEditorData(props.components, componentMeta);
    const updatedContentState = removeEntityAndReplaceText(
      editorData.data,
      entity.id,
    );
    const updatedSection = getUpdatedParentComponent(
      props.components,
      componentMeta,
      { ...editorData, data: updatedContentState },
    );
    updatedSection.oldFormFields = oldFormFields;

    updateTemplateComponentService(updatedSection).then(() => {
      delete updatedSection.oldFormFields;

      props.updateDocumentComponentAction(updatedSection);
      props.forceUpdateEditorSectionIdAction(componentMeta.componentId);
      Toastr.showToastr({
        type: "success",
        message: `${
          DOCUMENT_LABELS["dynamic-label"]
        } field successfully removed!`,
        timeout: 2000,
      });
    });
  }
  const dynamicFiledList = _getDynamicFieldList();
  return (
    <div
      className="dynamicfieldlist-container animated fadeinleft"
      data-test="dynamicfieldlist-container">
      <div
        className="dynamicfieldinfo-header"
        data-test="dynamicfieldlist-header">
        {DOCUMENT_LABELS["dynamic-label"]} fields in this template
      </div>
      <div className="dynamicfieldlist-body" data-test="dynamicfieldlist-body">
        <div className="content-scroll">
          <div
            className="dynamicfieldinfo-text addproduct-info"
            data-test="dynamicfieldinfo-body-text">
            Form fields are fillable placeholders. You can fill data in the
            fields when you create a document from this template.{" "}
            <a
              href="https://youtu.be/PNBR8CWdJbA?utm_source=revv%20app&utm_medium=create%20form%20field&utm_campaign=tutorial"
              rel="noopener noreferrer"
              target="_blank"
              data-test="dynamicfield-learn-more">
              Learn more
            </a>
          </div>
          {/** Listing of Dynamic Field and Clauses Section */}
          {dynamicFiledList.map(entity => (
            <div
              className="dynamicfieldlist-wrapper"
              key={entity.id}
              data-test="dynamicfieldlist-wrapper">
              <div
                className={`dynamicfieldlist-item ${entity.type.toLowerCase()}`}
                data-test="dynamicfieldlist-item"
                id={entity.id}>
                <div
                  className="dynamicfieldlist-info-wrapper"
                  data-test="dynamicfieldlist-info-wrapper"
                  onClick={() =>
                    entity.type === "DYNAMICFIELD"
                      ? _scrollToView(entity.id)
                      : _scrollToView(entity.sectionID)
                  }
                  onKeyPress={() => null}
                  role="button"
                  tabIndex="0">
                  {/* <div className="dynamicfieldlist-item-ico">
                  <FontAwesomeIcon icon={["fas", "thumbtack"]} />
                </div> */}

                  <div
                    className="dynamicfieldlist-item-info"
                    data-test="dynamicfieldlist-item-info">
                    <span data-test="dynamicfieldlist-item-info-dynamicfieldname">
                      {entity.workflowEnabled && (
                        <span
                          className="dynamicfieldlist-item-star"
                          data-test="dynamicfieldlist-item-info-staricon">
                          <FontAwesomeIcon icon={["far", "asterisk"]} />
                        </span>
                      )}
                      {entity.label}
                    </span>
                    <span data-test="dynamicfieldlist-item-info-description">
                      {entity.description}
                    </span>
                  </div>
                </div>
                <AttachWorkflowBtn
                  entity={entity}
                  removeDynamicFiled={_removeDynamicFiled}
                  goForUpdateFormField={_goForUpdateFormField}
                  {...props}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const {
    dynamicFields: { view },
  } = state.TemplateStore;

  const { components = {} } = state.DocumentStore;

  let {
    template: { fields_used: fields },
  } = state.TemplateStore;
  fields = fields || [];

  // Create a map for dynamicField obj
  const dynamicField = {};
  fields.forEach(field => {
    dynamicField[field.id] = field;
  });

  const coverpageId =
    components &&
    Object.keys(components).find(
      componentId =>
        components[componentId] &&
        components[componentId].content &&
        components[componentId].content.type ===
          DOCUMENT_COMPONENT_TYPES.COVERPAGE,
    );

  let coverpageFormFields = [];

  if (coverpageId) {
    const coverpage = components[coverpageId].content;
    if (
      coverpage.data &&
      coverpage.data.attributes &&
      !coverpage.data.attributes.isOpen &&
      Array.isArray(coverpage.form_field) &&
      coverpage.form_field.length > 0
    ) {
      const cpFieldIds = [];
      coverpage.form_field.forEach(item => cpFieldIds.push(item.id[0]));
      Object.keys(coverpage.data.components).forEach(componentId => {
        const component = coverpage.data.components[componentId].content;
        if (
          (component.type === DOCUMENT_COMPONENT_TYPES.HTML ||
            component.type === DOCUMENT_COMPONENT_TYPES.TABLE) &&
          Array.isArray(component.form_field) &&
          component.form_field.length > 0
        ) {
          coverpageFormFields = [
            ...coverpageFormFields,
            ...component.form_field,
          ];
        }
      });
    }
  }

  return { components, dynamicField, view, coverpageFormFields };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  toggleWorkFlowScreen,
  forceUpdateEditorSectionIdAction,
  updateDocumentComponentAction,
  getCustomFieldType,
  selectedDynamicFieldDataForUpdate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DynamicFieldList);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldList/DynamicFieldList.js